import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useSearchParams } from 'react-router-dom';
import { fetchCategories } from '../../../actions/cartoondraw/categoriesActions';
import { fetchAssets } from "../../../actions/cartoondraw/assetsActions";
import { clearAssets } from '../../../store/cartoondraw/assetsSlice';

import PageLayout from '../_partials/PageLayout';
import PageHeader from '../../../componets/PageHeader';
import NavBarTwo from '../../../componets/NavBarTwo';
import { RightSidebar } from "../../_partials/Layout";
import Wrapper from '../../../componets/Wrapper';
import NavBarThree from '../../../componets/NavBarThree';
import Summary from '../../../componets/Summary';
import AssetCard from '../_partials/AssetCard';
import { Spin } from "antd";
import './style.scss';

const Assets: React.FC = () =>  {
  const dispatch = useAppDispatch();
  const categories  = useAppSelector(state => state.cartoondraw.categories.entities);
  const categoryIds = useAppSelector(state => state.cartoondraw.categories.ids);
  const loading     = useAppSelector(state => state.cartoondraw.assets.loading);
  const assets      = useAppSelector(state => state.cartoondraw.assets.entities);
  const assetIds    = useAppSelector(state => state.cartoondraw.assets.ids);

  const [searchParams, setSearchParams] = useSearchParams();
  const [category, setCategory] = useState<any>();
  const [parentCategory, setParentCategory] = useState<any>();
  const [rightTab, setRightTab] = useState<string>('summary');

  useEffect(() => {
    if (!categories) {
      dispatch(fetchCategories());
    }
  }, []);

  // Redirect to the first category if category_id param is blank
  useEffect(() => {
    const categoryId: any = searchParams.get('category_id');

    if (!categoryId && categories) {
      setSearchParams(`category_id=${categoryIds[0]}`);
    }
  }, [categories]);

  useEffect(() => {
    const categoryId: any = searchParams.get('category_id');

    if (!categories || categoryId?.id === categoryId) {
      return;
    }

    const cat = categories[categoryId];

    if (!cat) {
      setCategory(null);
      setParentCategory(null);

      return;
    }

    if (cat.subcategories && cat.subcategories.length) {
      return setSearchParams(`category_id=${cat.subcategories[0]}`);
    }

    const parentCat = cat.parent_id ? categories[cat.parent_id] : null;

    setCategory(cat);
    setParentCategory(parentCat);
  }, [searchParams, categories]);

  useEffect(() => {
    if (category) {
      dispatch(fetchAssets(category.id));
    } else {
      dispatch(clearAssets());
    }
  }, [category]);

  function onClickReorderAsset() {}
  function onClickCreateAsset() {}

  function onClickCategorySettings() {}
  function onClickCreateCategory() {}

  function onClickRightTab(slug: string) {
    setRightTab(slug);
  }
  function onClickCreateSubcategory() {}

  const SummaryTab = () => {
    if (!category) {
      return null;
    }

    return (
      <Summary
        title={category.name}
        subtitle={category.subname}
        image={category.image_url}
        options={
          <NavBarThree>
            <NavBarThree.Button onClick={onClickCreateAsset}>Edit</NavBarThree.Button>
            <NavBarThree.Button onClick={onClickReorderAsset}>Delete</NavBarThree.Button>
          </NavBarThree>
        }
      />
    )
  }
  const SubcategoriesTab = () => {
    if (category.parent_id) {
      return null;
    }

    return (
      <>
        <button
          onClick={onClickCreateSubcategory}
          className="v-btn v-btn-primary v-btn-block"
        >
          Create Subcategory
        </button>
      </>
    );
  }

  const RightContainerTab = () => {
    switch (rightTab) {
      case 'summary':
        return <SummaryTab />;
      case 'subcategories':
        return <SubcategoriesTab />;
      default:
        return null;
    }
  }

  const RenderAssets = () => {
    return (
      <>
        {assets ? assetIds.map(id => <AssetCard asset={assets[id]} key={assets[id].id} />) : null}
      </>
    )
  }

  return (
    <PageLayout>
      <div>
        <PageHeader
          title={category?.name}
          breadcrumbs={[parentCategory?.name, category?.name]}
        >
          {
            categories &&
              <NavBarTwo
                  items={categories}
                  itemIds={categoryIds}
                  activeId={category?.id}
              />
          }

          <NavBarThree>
            <NavBarThree.Button onClick={onClickCategorySettings}>Category Settings</NavBarThree.Button>
            <NavBarThree.Button onClick={onClickCreateCategory}>Create Category</NavBarThree.Button>
          </NavBarThree>
        </PageHeader>

        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button onClick={onClickCreateAsset}>Reorder</NavBarThree.Button>
            <NavBarThree.Button onClick={onClickReorderAsset}>Create Asset</NavBarThree.Button>
          </NavBarThree>
        </Wrapper>

        <div className='v-assets'>
          {loading ? <Spin /> : <RenderAssets />}
        </div>
      </div>

      <RightSidebar>
        <h6 className='v-content-label'>CHOOSE OPTION</h6>

        <div className='v-options'>
          <NavBarThree>
            <NavBarThree.Button
              className={rightTab === 'summary' ? 'active' : ''}
              onClick={() => onClickRightTab('summary')}
            >
              Summary
            </NavBarThree.Button>
            <NavBarThree.Button
              className={rightTab === 'subcategories' ? 'active' : ''}
              onClick={() => onClickRightTab('subcategories')}
            >
              Subcategories
            </NavBarThree.Button>
          </NavBarThree>
        </div>

        <hr className="v-divider" />

        <h6 className="v-content-label o-sm">{rightTab}</h6>

        {<RightContainerTab />}
      </RightSidebar>
    </PageLayout>
  );
}

export default Assets;
